import { I18n } from '@calendly/i18n'

import { useUpdateEventTypeMutation } from 'features/event_type_editor/api'
import { useEventType } from 'features/event_type_provider'

import { useGoBack } from '../../../../use_go_back'
import { BaseNotificationSection } from '../base_notification_section'
import { getInitialValues } from '../config'

export const CalendarInvitationSection = () => {
  const eventType = useEventType()
  const [updateEventType, { error }] = useUpdateEventTypeMutation({ id: eventType.id })
  const goBack = useGoBack()

  const onSubmit = (values) => {
    const initialValues = getInitialValues(eventType, 'invitee_invitation')
    const attributes = values

    if (initialValues.assignedSenderId !== values.assigned_sender_id) {
      attributes.event_type_memberships_attributes = eventType.memberships.map(({ id }) => ({
        id,
        primary: id === values.assigned_sender_id
      }))
    }

    return updateEventType({
      eventType,
      attributes,
      onSuccess: goBack,
    })
  }

  return (
    <BaseNotificationSection
      kind="invitee_invitation"
      eventType={{ ...eventType, notification_type: 'calendar' }}
      skipDirtyCheck={eventType.notification_type !== 'calendar'}
      description={I18n.t('publisher.event_type_editor.sections.communications.invitation_confirmation.calendar_body')}
      externalError={error}
      onSubmit={onSubmit}
    />
  )
}
